import { render, staticRenderFns } from "./case4.vue?vue&type=template&id=13b122f4&scoped=true&"
import script from "./case4.vue?vue&type=script&lang=js&"
export * from "./case4.vue?vue&type=script&lang=js&"
import style0 from "./case4.vue?vue&type=style&index=0&id=13b122f4&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "13b122f4",
  null
  
)

export default component.exports